export default __webpack_public_path__ + "static/media/ci-map-zoom-out.98ba78eb.svg";